export class weightageuserwiseModel {
  RoleListAPI: string;
  weightageuserwiseListAPI: string;
  weightageuserwiseIDAPI: string;
  weightageuserwiseUpdateAPI: string;
  WeightageRoleListAPI: string;
  NewUserRoledetailsAPI: string;
  WeightageAddUserAPI: string;
  TransforUserAPI: string;
  RejectUserUpdateAPI: string;
  GetAllBUHeadListAPI: string;
  DepartmentsListByBUHeadAPI: string;


}

